import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import NewsSubnav from "./news_subnav";
import NewsView from "./news_view";
import Header from "./news_header";

function NewsPage() {
  return (
    <div>
      <Header />
      <NewsSubnav />
      <NewsView />
    </div>
  );
}

export default NewsPage;
